export default __webpack_public_path__ + "static/media/crew-04.21c7d33a.svg";